import { Button } from 'antd'
import React from 'react'
import useQueryParam from '../../../../../../hooks/useQueryParam'
import { FlagFilled, FlagOutlined } from '@ant-design/icons'
import { errorColor } from '../../../../../../constants/styles'
import { useUpdateQuestionAnswerEscalatedMutation } from '../../../../../../store/apis/submission.api'
import { useVersionId } from '../../../../../../utils/parseURL.helper'
import { SUBMISSION_SEARCH_PARAM } from '../../../../../../constants/query-params'
import { useParams } from 'react-router'
import { useSelectNextEscalatedQuestion } from '../../../../../../store/apis/utils/hooks/text-submission.hooks'
import { ExplainabilityStatuses } from '../../../../../../constants/explainability-statuses'

const FlagToggle = ({ answerId, questionId, submissionId, flagged }) => {
    const search = useQueryParam(SUBMISSION_SEARCH_PARAM)
    const versionId = useVersionId()
    const { token } = useParams()

    const isUnresolved = flagged == ExplainabilityStatuses.MANUAL_UNRESOLVED

    const [updateQuestionAnswerEscalated] = useUpdateQuestionAnswerEscalatedMutation()

    const goToNext = useSelectNextEscalatedQuestion(answerId, submissionId)

    const handleClick = async () => {
        await updateQuestionAnswerEscalated({
            id: answerId,
            questionId,
            submissionId,
            escalated: isUnresolved ? ExplainabilityStatuses.MANUAL_RESOLVED : ExplainabilityStatuses.MANUAL_UNRESOLVED,
            search,
            versionId,
            token,
        })

        if (isUnresolved) {
            goToNext()
        }
    }

    return (
        <>
            <Button
                type='text'
                icon={flagged ? <FlagFilled style={{ color: errorColor }} /> : <FlagOutlined />}
                onClick={handleClick}
                title={isUnresolved ? 'Clear flag' : 'Flag for Review'}
            />
        </>
    )
}

export default FlagToggle
